$(function () {
    const $placementsTable = $('#yr5-placements-table');

    if ($placementsTable.length === 0) {
        return;
    }

    const satisfactionView = typeof isSatisfactionView !== 'undefined' && isSatisfactionView;

    const satisfactionColumnIndex = $placementsTable.find('thead th').toArray().findIndex(function (headerCell) {
        return $(headerCell).text().trim() === 'Satisfaction';
    });

    $placementsTable.DataTable({
        pageLength: -1,
        lengthMenu: [[25, 50, 100, 200, -1], [25, 50, 100, 200, 'All']],
        order: satisfactionView && satisfactionColumnIndex !== -1
            ? [[satisfactionColumnIndex, 'desc']]
            : [[1, 'asc'], [0, 'asc']],
        autoWidth: true,
    });
});
